goog.provide("shadow.js.shim.module$src$svg$path$tree_vertical_svg$default");
shadow.js.shim.module$src$svg$path$tree_vertical_svg$default = shadow.js.shim.module$src$svg$path$tree_vertical_svg.default;
